import React, { useState } from 'react';
import './ApiDetails.css';
import moment from 'moment';
import { Dialog, Input, TextArea, BUTTON_VARIANTS, Card } from "cdk-radial";

const INPUTS = {
    NAME: {
        id: "contact-support-name",
        label: "Name",
        name: "name",
        maxLenght: 40
    },
    EMAIL: {
        id: "contact-support-email",
        label: "From",
        name: "email",
        errorMessage: 'Enter valid email'
    },
    MESSAGE: {
        id: "contact-support-message",
        label: "Message",
        name: "message",
        maxLenght: 250
    },
}
let date = new Date();
let dateComponent = moment(date)
    .utc()
    .format('YYYY-MM-DD');
let timeComponent = moment(date)
    .utc()
    .format('HH:mm:ss');



const ContactSupportDialog = (props) => {
    const {
        auth: { userData }, open, onClose, orgName, apiDetailsOnClickHandlers, sendingEmailToConsumer, sendingEmailToProvider
    } = props;
    const [name, setName] = useState(userData.name || "");
    const [email, setEmail] = useState(userData.email || "");
    const [message, setMessage] = useState('');
    const [emailError, setEmailError] = useState(false);
    const TITLE = `Contact ${orgName ? orgName : null}`

    const createConsumerEmailPayload = async () => {
        const {
            auth: { userData }
        } = props;
        let confirmationToConsumer = {
            templateIdentifier: 'l/149371/2020-03-31/4t7wk6',
            emailContentSubstitutions: {
                firstName: userData.name,
                email: userData.email,
                apiName: props.apiName,
                date: dateComponent,
                time: `${timeComponent} UTC`,
                apiProviderName: props.providerName,
                message: message
            }
        };
        await apiDetailsOnClickHandlers.sendEmailToConsumer(confirmationToConsumer);
    };

    const createProviderEmailPayload = async () => {
        let contactSupportMsgToProvider = {
            templateIdentifier: 'l/149371/2020-03-31/4t7wp4',
            emailContentSubstitutions: {
                apiName: props.apiName,
                firstName: props.providerName,
                email: props.providerSupportEmail,
                userName: name,
                userEmail: email,
                date: dateComponent,
                time: `${timeComponent} UTC`,
                message: message
            }
        };
        await apiDetailsOnClickHandlers.sendEmailToProvider(contactSupportMsgToProvider);
    };

    const sendEmail = async () => {
        await createProviderEmailPayload();
        await createConsumerEmailPayload();
        handleClose();
    };

    const handleInputChange = event => {
        if (event.target.name === INPUTS.NAME.name)
            setName(event.target.value);
        else if (event.target.name === INPUTS.EMAIL.name) {
            setEmail(event.target.value);
        }
        else if (event.target.name === INPUTS.MESSAGE.name) {
            setMessage(event.target.value)
        }
    };

    const handleInputBlur = event => {
        let isValid = false;
        const value = event.target.value;
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
        if (event.target.name === INPUTS.EMAIL.name) {
            isValid = emailRegex.test(value);
        }
        setEmailError(!isValid)
    }

    const handleClose = () => {
        setName(userData.name);
        setEmail(userData.email);
        setMessage("");
        setEmailError(false);
        onClose();
    }

    return (
        <>
            <Dialog
                id="contact-support-dialog"
                style={{ width: '600px' }}
                isOpen={open}
                title={TITLE}
                dataTestId="contact-support-dialog"
                hideCloseButton={false}
                onClose={handleClose}
                disableOverlayClicked={false}
                buttonsProps={[
                    {
                        id: "api-edit-dialog-cancel",
                        onClick: handleClose,
                        text: "Cancel",
                        variant: BUTTON_VARIANTS.TEXT,
                    },
                    {
                        id: "api-edit-dialog-save",
                        onClick: sendEmail,
                        text: "Submit",
                        variant: BUTTON_VARIANTS.PRIMARY,
                        isDisabled: emailError || !name || !message,
                        isLoading: sendingEmailToConsumer || sendingEmailToProvider
                    },
                ]}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div>
                        <Input
                            helperText={INPUTS.NAME.helperText}
                            id={INPUTS.NAME.id}
                            label={INPUTS.NAME.label}
                            name={INPUTS.NAME.name}
                            onChange={handleInputChange}
                            value={name}
                            className={"api-edit-input"}
                            isRequired={true}
                            enableIsRequiredValidation={true}
                            hasCharacterCount={true}
                            maxLength={INPUTS.NAME.maxLenght}
                            dataTestId={`input-${INPUTS.NAME.name}`}
                        />
                    </div>
                    <div>
                        <Input
                            helperText={INPUTS.EMAIL.helperText}
                            id={INPUTS.EMAIL.id}
                            label={INPUTS.EMAIL.label}
                            name={INPUTS.EMAIL.name}
                            onChange={handleInputChange}
                            value={email}
                            className={"api-edit-input"}
                            isRequired={true}
                            onBlur={handleInputBlur}
                            enableCustomValidation
                            hasError={emailError}
                            errorMessage={INPUTS.EMAIL.errorMessage}
                            dataTestId={`input-${INPUTS.EMAIL.name}`}
                        />
                    </div>
                    <div>
                        <TextArea
                            helperText={INPUTS.MESSAGE.helperText}
                            dataTestId={`input-${INPUTS.MESSAGE.name}`}
                            id={INPUTS.MESSAGE.id}
                            label={INPUTS.MESSAGE.label}
                            name={INPUTS.MESSAGE.name}
                            onChange={handleInputChange}
                            value={message}
                            hasCharacterCount={true}
                            maxLength={INPUTS.MESSAGE.maxLenght}
                            isRequired={true}
                            enableIsRequiredValidation={true}
                            rows={5}
                        />
                    </div>
                    <div>
                        <Card className='api-dir-pkg_info-card'><span>By clicking Submit, you agree to send your contact information to <b>{orgName}</b>.</span></Card>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default ContactSupportDialog;
